/* global barba, barbaRouter, urlForUser, urlForUserLogin */
import helpers from './helpers';
import parallax from './components/parallax';
import test from './components/test';
import {def, intro} from './components/animations';
import analytics from './components/analytics';
import introItems from './components/intro';
import {initVideo} from './video';

const routes = [
	{
		path: '/:test',
		name: 'test',
	}, {
		path: '/',
		name: 'home',
	},
];

barba.use(barbaRouter, {
	routes,
});

barba.hooks.beforeLeave((data) => {
	return new Promise((resolve) => {
		if (data.trigger.className === 'intro__item') {
			gsap.to($(data.trigger).find('.intro__item-picture'), {
				y: 500,
				duration: 0.4,
				onComplete() {
					resolve();
				},
			});
		} else {
			resolve();
		}
	});
});

barba.hooks.afterLeave((data) => {
	if (data.current.namespace === 'test') {
		test.destroy($(data.next.container));
	}
	introItems.destroy();

	parallax.destroy();
});

barba.hooks.beforeEnter(() => {
	helpers.scrollTo(helpers.$body);
});

barba.hooks.enter(() => {
	objectFitImages();

	// FIT ON ENTER NEXT PAGE
	// objectFitVideos();
});

barba.hooks.afterEnter((data) => {
	if (data.current.namespace) {
		analytics.init(data.next);
	}

	if (data.next.namespace === 'home') {
		intro(!helpers.getCookie('recommendation'));
	}

	if (data.next.namespace === 'test') {
		test.init($(data.next.container));
		initVideo('.test');

		// FIT VIDEO
		// objectFitVideos();
	}
});

barba.hooks.afterOnce(() => {
	analytics.init();
});

// init Barba
barba.init({
	sync: true,
	logLevel: 'error',
	transitions: [def],
	debug: true,
	prevent(data) {
		if (location.pathname + location.search === data.href) {
			data.event.preventDefault();

			return true;
		}

		return false;
	},
	requestError(trigger, action, url, response) {
		if (action === 'click' && response.status && response.status === 404) {
			barba.go('/');
		}

		return false;
	},
});
